import { useEffect, useState } from "react";
import ContaContabilService from "../../services/resource/ContaContabilService";
import UsuarioService from "../../services/resource/usuarioService";
import CrudTemplate from "../crudTemplate";

export default function ContaContabilCrud() {
    const [usuarios, setUsuarios] = useState([]);
    const usuarioService = new UsuarioService();

    useEffect(() => {
        usuarioService.listarUsuarios().then(res => {
            setUsuarios(res.data);
        })
    }, []);

    const service = new ContaContabilService();
    const formFields = [
        { name: "codigo", label: "Código", type: "input", placeholder: "Ex: 1.01" },
        { name: "reduzido", label: "Reduzido", type: "input", typeText: 'number', placeholder: "Ex: 4500", colSpan: 1 },
        { name: "descricao", label: "Descrição", type: "input", placeholder: "Ex: Fornecedor de Serviços", colSpan: 2 },
        {
            name: "natureza", label: "Natureza", type: "select", options: [{ value: "", label: "Selecione" },
            { value: "D", label: "Débito" }, { value: "C", label: "Crédito" }]
        },
        { name: "contaMae", label: "Conta Mãe", type: "input", placeholder: "Ex: 4.002", colSpan: 1 },
        { name: "tipo", label: "Tipo", type: "input", placeholder: "Ex: Desp.Adm.", colSpan: 1 },
    ];

    const tableColumns = [
        { key: "codigo", label: "Código", bold: true },
        { key: "reduzido", label: "Reduzido", bold: true },
        { key: "descricao", label: "Descrição" },
        {
            key: "natureza", label: "Natureza", render: (value) => (
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${value === "Débito" ? "bg-success/10 text-success" : "bg-primary/10 text-primary"}`}>
                    {value}
                </span>
            )
        },
        { key: "contaMae", label: "conta Mãe" },
        { key: "tipo", label: "Tipo" },

    ];

    return <CrudTemplate
        title="Gerenciar Contas Contábeis"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '95%' }}
        modalHeader="Conta Contábil"
    />;
}